import Vuex from 'vuex'
import axios from 'axios'

const createStore = () => {
  return new Vuex.Store({
    state: {
      loading: false,
      modalCover: false,
      submissionStatus: false,
      contactStatus: false,
      showContact: false,
      step: 1,
      shareStatus: 0,
      eShareStatus: {
        saved: 1,
        link: 2,
        linkedIn: 3,
        contact: 4
      },
      locale: 'de', // fallback locale, will be overridden by Pimcores initData
      host: 'http://localhost', // fallback host, will be overridden by Pimcores initData
      proxy: {
        'post': '/service/recipe/save',
        'get': '/service/recipe/load',
        'contact': '/service/contact/send'
      },
      catalogue: '',
      logo: '/src/img/fortisa.svg', // fallback logo
      responseReady: false,
      lastResponse: {},

      errors: {
        'recipeName': true
      },
      activeFilters: {},
      fieldValues: {
        recipeName: '',
        recipeSearch: ''
      },

      contact: {},
      contactEmail: 'info@fortisa.ch', // fallback email
      options: ['sizes', 'colours', 'doughs', 'seedings', 'surfaces', 'labels'],
      resetOptionIcon: '',
      filters: [],
      buns: [],
      sizes: [],
      colours: [],
      doughs: [],
      seedings: [],
      surfaces: [],
      labels: [],
      recipes: [],
      emojis: [],
      emojiMap: [],
      curRecipe: {
        name: '',
        bun: {},
        size: {},
        colour: {},
        dough: {},
        seeding: {},
        surface: {},
        label: {},
        emojiMap: [],
      },
    },
    mutations: {
      /**
       *
       * @param state
       * @param payload   - initial data object
       */
      initialiseStore (state, payload) {
        this.replaceState(Object.assign(state, payload))
      },

      /**
       * set recipe name
       * @param state
       * @param name
       */
      setRecipeName (state, name) {
        state.curRecipe.name = name
      },

      /**
       * select bun for current recipe
       * @param state
       * @param bun     - bun object
       */
      selectBun (state, bun) {
        state.curRecipe.bun = bun
      },

      /**
       * set selected option to current recipe
       * @param state
       * @param type    - expected type in singular form eg. size, colour, etc.
       * @param option  - id oder option object
       */
      selectOption (state, { type, option }) {
        //get object when id is passed
        if (Number.isInteger(option)) {
          option = this.getters.byId(type + 's', option)
        }

        //assign object to current recipe
        state.curRecipe[type] = option
      },

      /**
       * clear last response
       * @param state
       */
      clearLastResponse (state) {
        state.responseReady = false
        state.lastResponse = {}
      },

      /**
       * set submission status
       * @param state
       * @param status    - true for ready
       */
      setSubmissionStatus (state, status) {
        state.submissionStatus = status
      },

      /**
       * set show/hide ModalCover
       * @param state
       * @param status
       */
      showModalCover (state, status) {
        state.modalCover = status
      },

      /**
       * enable filter
       * @param state
       * @param type      - filter option name
       * @param id        - filter id
       */
      enableFilter (state, { type, id }) {
        if (state.activeFilters[type] === undefined) {
          state.activeFilters[type] = [id]
        } else {
          // ensure filter is only once added
          if (state.activeFilters[type].indexOf(id) == -1)
            state.activeFilters[type].push(id)
        }
      },

      /**
       * disable filter
       * @param state
       * @param type      - filter option name
       * @param id        - filter id
       */
      disableFilter (state, { type, id }) {
        if (this.state.activeFilters[type] !== undefined) {
          let i = this.state.activeFilters[type].indexOf(id)

          if (i > -1)
            state.activeFilters[type].splice(i)
        }
      },

      /**
       * reset all active filters
       * @param state
       */
      resetFilters (state) {
        state.activeFilters = {}
      },

      /**
       * set error status
       * @param state
       * @param type      - element name
       * @param status    - true for error
       */
      setErrorStatus (state, { type, status }) {
        state.errors[type] = status
      },

      /**
       * set field value
       * @param state
       * @param field
       * @param value
       */
      setFieldValue (state, { field, value }) {
        state.fieldValues[field] = value
      },

      /**
       * set conatact status
       * @param state
       * @param status
       */
      setContactStatus (state, status) {
        state.showContact = status
      },

      setStep (state, step) {
        state.step = step
      },

      setShareStatus (state, status) {

        if(Number.isInteger(status)) {
          state.shareStatus = status

        } else {

          if (state.eShareStatus[status] === undefined) {
            return
          }

          state.shareStatus = state.eShareStatus[status]
        }
      },

      resetShareStatus (state) {
        state.shareStatus = 0
      },

      setEmojiMap (state, map) {
        state.curRecipe.emojiMap = map
      },

      /**
       * add new emoji map
       * @param state
       * @param emoji
       */
      addEmojiToMap (state, emoji) {
        state.curRecipe.emojiMap.push({
          id: emoji.id + '#' + Date.now(),
          emojiId: emoji.id,
          transform: {
            x: 0,
            y: 0,
            w: 10,
            h: 10,
            rotation: 0,
          }
        })
      },

      /**
       * remove emoji map entity
       * @param state
       * @param id
       */
      removeEmojiFromMap (state, id) {
        let pos = state.curRecipe.emojiMap.findIndex(e => e.id === id)

        if (pos > -1) {
          // replace emoji with empty object, as removing it from array causes a order bug in moveable
          state.curRecipe.emojiMap.splice(pos, 1, {})
        }
      },

      updateEmoji (state, emoji) {

        let pos = state.curRecipe.emojiMap.findIndex(e => e.id === emoji.id)

        if (pos > -1) {
          state.curRecipe.emojiMap[pos] = emoji
        }
      }
    },

    actions: {
      /**
       * save recipe
       * @param context
       */
      async saveRecipe (context) {
        //enable loading1
        context.state.loading = true

        // Send JSON body (backend expects raw JSON via Request::getContent())
        const config = {
          headers: {
            'Content-Type': 'application/json'
          }
        }

        // get current recipe
        let curRecipe = context.state.curRecipe

        // prepare recipe data as plain JSON (no FormData)
        const payload = {
          name: curRecipe.name,
          bun: curRecipe.bun.id,
          size: curRecipe.size.id,
          colour: curRecipe.colour.id,
          dough: curRecipe.dough.id,
          // backend expects an array of objects here, not a JSON string
          emojiMap: curRecipe.emojiMap || []
        }
        if (curRecipe.label && curRecipe.label.id !== undefined) {
          payload.label = curRecipe.label.id
        }

        // set seeding if defined
        if (curRecipe.seeding && curRecipe.seeding.id !== undefined) {
          payload.seeding = curRecipe.seeding.id
        }

        // set surface if defined
        else if (curRecipe.surface && curRecipe.surface.id !== undefined) {
          payload.surface = curRecipe.surface.id
        }

        // commit recipe to the server
        return new Promise((resolve, reject) => {
          axios.post(context.state.host + context.state.proxy.post, JSON.stringify(payload), config)
            .then((response) => {
              if (response.data.success) {
                //disable loading
                context.state.loading = false
                /// set response data
                context.state.lastResponse = response.data.data
                // set response ready state
                context.state.responseReady = true
              }

              resolve(response)
            })
            .catch((error) => {
              context.state.loading = false
              alert(error)
              reject(error)
            })
        });
      },

      /**
       * load recipe
       * @param context
       * @param hash
       * @returns AxiosPromise
       */
      loadRecipe: (context, hash) => {
        //enable loading
        context.state.loading = true

        // prepare request header
        let config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            // 'Access-Control-Allow-Origin': '*' // @todo remove for production
          },
        }

        return new Promise((resolve, reject) => {
          axios.get(context.state.host + context.state.proxy.get, { params: { hash: hash } }, config).then((response) => {
            //ensure bun was found otherwise cancel loading recipe
            if (!response.data.success) {
              context.state.loading = false
              resolve(response)

              return
            }

            //get bun by id
            let bun = context.getters.byId('buns', parseInt(response.data.recipe.bun))

            //commit recipe name
            context.commit('setRecipeName', response.data.recipe.name)
            //commit recipe bun
            context.commit('selectBun', bun)

            //disable loading
            context.state.loading = false
            resolve(response)
          })
        })
      },

      /**
       * save contact data
       * @param state
       * @param getters
       * @param data
       * @returns AxiosPromise
       */
      sendContact: ({ state, getters }, data) => {
        // prepare request header
        let config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            // 'Access-Control-Allow-Origin': '*', // @todo remove for production
          },
        }

        data.append('locale', state.locale)
        data.append('recipe', getters.recipeId)

        // commit contact data to the server
        return axios.post(state.host + state.proxy.contact, data, config)
      }
    },
    getters: {
      /**
       * get host
       * @param state
       * @returns string
       */
      host: state => {
        return () => state.host
      },

      /**
       * get locale
       * @param state
       * @returns string
       */
      locale: state => {
        return () => state.locale
      },

      shareUrl: state => {
        if(state.lastResponse.hash === undefined)
          return null

        return state.host + '/' + state.locale + '/' + state.lastResponse.hash
      },

      loading: state => {
        return state.loading
      },

      /**
       * get logo
       * @param state
       * @returns string
       */
      logo: state => {
        return state.logo
      },

      /**
       * get configurator step
       * @param state
       * @returns number
       */
      step: state => {
        return () => state.step
      },

      shareStatus: state => {
        return state.shareStatus
      },

      /**
       * get option object by type and id
       * @param state
       * @param type      - option name
       * @param id
       * @returns object
       */
      byId: state => {
        return (type, id) => state[type].find((x) => x.id === id)
      },

      /**
       * get filters for option type
       * @param state
       * @param type      - option name
       * @returns array
       */
      filterByOption: state => {
        return (type) => state.filters.filter((filter) => {
          return filter.then.optionType === type
        })
      },

      /**
       * get filter by id
       * @param state
       * @param id        - filter id
       * @returns object
       */
      filterById: state => {
        return (id) => state.filters.find((filter) => {
          return filter.id === id
        })
      },

      /**
       * get active filters
       * @param state
       * @returns array
       */
      activeFilters: state => {
        return state.activeFilters
      },

      /**
       * get all options which are valid for current bun
       * @param state
       * @returns function
       */
      activeOptions: state => {
        return (type) => {
          //show no options when no bun is selected
          if ((Object.keys(state.curRecipe.bun).length > 0) && (state.curRecipe.bun.options[type] !== undefined)) {
            //filter options if they are not allowed for current bun
            return state.curRecipe.bun.options[type].filter((id) => {
              return state.curRecipe.bun.options[type].includes(id)
            })
          } else {
            return []
            // return state[type]; // used to show all opitons => buggy
          }
        }
      },

      /**
       * get recipes
       * @param state
       * @returns array
       */
      recipes: state => {
        // filter list by name when the search string is >= 3 chars
        return state.recipes.filter((recipe) => {
          return (state.fieldValues['recipeSearch'].length < 3) || (recipe.name.toLowerCase().indexOf(state.fieldValues['recipeSearch'].toLowerCase()) > -1)
        })
      },

      /**
       *
       * @param state
       * @returns {*}
       */
      recipeId: state => {
        return (state.lastResponse.id === undefined) ? 0 : state.lastResponse.id
      },

      catalogueUrl: state => {
        return state.catalogue
      },

      emojis: state => {
        return state.emojis
      },

      emojiMap: state => {
        return state.curRecipe.emojiMap
      }
    }
  })
}

export default createStore
